













export default {
  props: {
    suggestedCost: { type: Number, default: 0 }
  }
}
